import { QuestionBase } from './question-base';

export class LocationSearchQuestion extends QuestionBase<string> {
  controlType = 'location';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
